"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'RedPacketPrizePane',
  components: {},
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          id: '',
          prizeType: 1,
          couponId: '',
          couponName: '',
          usedStock: 0,
          stock: 0,
          couponCount: 0,
          winRate: 0,
          integral: 0
        };
      }
    },
    currPrizeMap: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      couponLoading: false,
      couponList: [],
      couponReward: _objectSpread({}, this.value),
      minStock: 1,
      minCouponCount: 1,
      minIntegral: 1
    };
  },
  watch: {
    couponReward: {
      handler: function handler(newValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.value)) {
          this.$emit('input', _objectSpread({}, newValue)); // 发送副本以避免引用问题
        }
      },
      deep: true,
      immediate: true
    },
    value: {
      immediate: true,
      handler: function handler(newValue) {
        // 检查新值是否与当前值不同，避免不必要的更新
        if (JSON.stringify(newValue) !== JSON.stringify(this.couponReward)) {
          this.couponReward = _objectSpread({}, newValue);
        }
      }
    }
  },
  created: function created() {
    var idd = this.value.id;
    if (this.currPrizeMap && Object.keys(this.currPrizeMap).length > 0 && this.currPrizeMap.hasOwnProperty(idd)) {
      var currPrize = this.currPrizeMap[idd];
      if (currPrize) {
        this.minStock = currPrize.stock || 1;
        this.minCouponCount = currPrize.couponCount || 1;
        this.minIntegral = currPrize.integral || 1;
      }
    }
  },
  methods: {}
};